import React from 'react';

type IconProps = {
  color?: string;
};

const defaultColor = '#212121';

export function HomeIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_714_33976)">
        <path
          d="M13.1421 6.9493L4.49972 14.0673V21.7496C4.49972 21.9485 4.57874 22.1393 4.7194 22.2799C4.86005 22.4206 5.05081 22.4996 5.24972 22.4996L10.5025 22.486C10.7008 22.485 10.8906 22.4056 11.0304 22.265C11.1703 22.1245 11.2488 21.9343 11.2488 21.736V17.2496C11.2488 17.0507 11.3278 16.8599 11.4685 16.7193C11.6091 16.5786 11.7999 16.4996 11.9988 16.4996H14.9988C15.1977 16.4996 15.3885 16.5786 15.5291 16.7193C15.6698 16.8599 15.7488 17.0507 15.7488 17.2496V21.7327C15.7485 21.8314 15.7676 21.9292 15.8052 22.0205C15.8428 22.1117 15.898 22.1947 15.9676 22.2646C16.0373 22.3345 16.1201 22.3899 16.2112 22.4278C16.3024 22.4656 16.4001 22.4851 16.4988 22.4851L21.7497 22.4996C21.9486 22.4996 22.1394 22.4206 22.2801 22.2799C22.4207 22.1393 22.4997 21.9485 22.4997 21.7496V14.0621L13.8593 6.9493C13.7577 6.86742 13.6311 6.82277 13.5007 6.82277C13.3702 6.82277 13.2436 6.86742 13.1421 6.9493ZM26.7935 11.7873L22.8747 8.55711V2.06445C22.8747 1.91527 22.8155 1.77219 22.71 1.66671C22.6045 1.56122 22.4614 1.50195 22.3122 1.50195H19.6872C19.538 1.50195 19.395 1.56122 19.2895 1.66671C19.184 1.77219 19.1247 1.91527 19.1247 2.06445V5.46805L14.928 2.01523C14.5253 1.68382 14.0199 1.50262 13.4983 1.50262C12.9767 1.50262 12.4714 1.68382 12.0686 2.01523L0.203163 11.7873C0.146204 11.8343 0.0990799 11.8922 0.0644824 11.9575C0.0298849 12.0228 0.00849254 12.0943 0.00152757 12.1678C-0.0054374 12.2414 0.00216156 12.3156 0.0238903 12.3862C0.045619 12.4569 0.0810515 12.5225 0.128163 12.5795L1.32348 14.0326C1.37046 14.0897 1.42825 14.137 1.49354 14.1718C1.55883 14.2065 1.63033 14.2281 1.70396 14.2352C1.77758 14.2423 1.85189 14.2348 1.92261 14.2131C1.99334 14.1915 2.0591 14.1561 2.11613 14.109L13.1421 5.02742C13.2436 4.94554 13.3702 4.90089 13.5007 4.90089C13.6311 4.90089 13.7577 4.94554 13.8593 5.02742L24.8857 14.109C24.9426 14.1561 25.0082 14.1915 25.0789 14.2133C25.1495 14.235 25.2237 14.2426 25.2973 14.2356C25.3709 14.2287 25.4423 14.2073 25.5076 14.1727C25.5729 14.1381 25.6308 14.0909 25.6778 14.034L26.8732 12.5809C26.9202 12.5236 26.9555 12.4576 26.977 12.3867C26.9985 12.3157 27.0057 12.2412 26.9983 12.1675C26.9909 12.0937 26.969 12.0222 26.9338 11.9569C26.8987 11.8917 26.851 11.834 26.7935 11.7873Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_714_33976">
          <rect width="27" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PickUpIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_714_2653)">
        <mask
          id="mask0_714_2653"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect
            width="24"
            height="24"
            transform="matrix(-1 0 0 1 24 0.5)"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_714_2653)">
          <path
            d="M18 20.5C18.8333 20.5 19.5417 20.2083 20.125 19.625C20.7083 19.0417 21 18.3333 21 17.5H23V6.5C23 5.95 22.804 5.47933 22.412 5.088C22.0207 4.696 21.55 4.5 21 4.5H7V8.5H4L1 12.5V17.5H3C3 18.3333 3.29167 19.0417 3.875 19.625C4.45833 20.2083 5.16667 20.5 6 20.5C6.83333 20.5 7.54167 20.2083 8.125 19.625C8.70833 19.0417 9 18.3333 9 17.5H15C15 18.3333 15.2917 19.0417 15.875 19.625C16.4583 20.2083 17.1667 20.5 18 20.5ZM18 18.5C17.7167 18.5 17.479 18.404 17.287 18.212C17.0957 18.0207 17 17.7833 17 17.5C17 17.2167 17.0957 16.9793 17.287 16.788C17.479 16.596 17.7167 16.5 18 16.5C18.2833 16.5 18.521 16.596 18.713 16.788C18.9043 16.9793 19 17.2167 19 17.5C19 17.7833 18.9043 18.0207 18.713 18.212C18.521 18.404 18.2833 18.5 18 18.5ZM21 15.5H20.2C19.9167 15.2 19.5917 14.9583 19.225 14.775C18.8583 14.5917 18.45 14.5 18 14.5C17.55 14.5 17.1417 14.5917 16.775 14.775C16.4083 14.9583 16.0833 15.2 15.8 15.5H9V6.5H21V15.5ZM6 18.5C5.71667 18.5 5.47933 18.404 5.288 18.212C5.096 18.0207 5 17.7833 5 17.5C5 17.2167 5.096 16.9793 5.288 16.788C5.47933 16.596 5.71667 16.5 6 16.5C6.28333 16.5 6.52067 16.596 6.712 16.788C6.904 16.9793 7 17.2167 7 17.5C7 17.7833 6.904 18.0207 6.712 18.212C6.52067 18.404 6.28333 18.5 6 18.5ZM7 13.5H2.75L5 10.5H7V13.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_714_2653">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DeliveryIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_74116)">
        <mask
          id="mask0_726_74116"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_74116)">
          <path
            d="M6 20.5C5.16667 20.5 4.45833 20.2083 3.875 19.625C3.29167 19.0417 3 18.3333 3 17.5H1V6.5C1 5.95 1.196 5.47933 1.588 5.088C1.97933 4.696 2.45 4.5 3 4.5H17V8.5H20L23 12.5V17.5H21C21 18.3333 20.7083 19.0417 20.125 19.625C19.5417 20.2083 18.8333 20.5 18 20.5C17.1667 20.5 16.4583 20.2083 15.875 19.625C15.2917 19.0417 15 18.3333 15 17.5H9C9 18.3333 8.70833 19.0417 8.125 19.625C7.54167 20.2083 6.83333 20.5 6 20.5ZM6 18.5C6.28333 18.5 6.521 18.404 6.713 18.212C6.90433 18.0207 7 17.7833 7 17.5C7 17.2167 6.90433 16.9793 6.713 16.788C6.521 16.596 6.28333 16.5 6 16.5C5.71667 16.5 5.479 16.596 5.287 16.788C5.09567 16.9793 5 17.2167 5 17.5C5 17.7833 5.09567 18.0207 5.287 18.212C5.479 18.404 5.71667 18.5 6 18.5ZM3 15.5H3.8C4.08333 15.2 4.40833 14.9583 4.775 14.775C5.14167 14.5917 5.55 14.5 6 14.5C6.45 14.5 6.85833 14.5917 7.225 14.775C7.59167 14.9583 7.91667 15.2 8.2 15.5H15V6.5H3V15.5ZM18 18.5C18.2833 18.5 18.5207 18.404 18.712 18.212C18.904 18.0207 19 17.7833 19 17.5C19 17.2167 18.904 16.9793 18.712 16.788C18.5207 16.596 18.2833 16.5 18 16.5C17.7167 16.5 17.4793 16.596 17.288 16.788C17.096 16.9793 17 17.2167 17 17.5C17 17.7833 17.096 18.0207 17.288 18.212C17.4793 18.404 17.7167 18.5 18 18.5ZM17 13.5H21.25L19 10.5H17V13.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_74116">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ReportIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_23098)">
        <mask
          id="mask0_726_23098"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_23098)">
          <path
            d="M3 21.5V19.5L5 17.5V21.5H3ZM7 21.5V15.5L9 13.5V21.5H7ZM11 21.5V13.5L13 15.525V21.5H11ZM15 21.5V15.525L17 13.525V21.5H15ZM19 21.5V11.5L21 9.5V21.5H19ZM3 16.325V13.5L10 6.5L14 10.5L21 3.5V6.325L14 13.325L10 9.325L3 16.325Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_23098">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ManifestIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_20277)">
        <mask
          id="mask0_726_20277"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_20277)">
          <path
            d="M8 18.5H16V16.5H8V18.5ZM8 14.5H16V12.5H8V14.5ZM6 22.5C5.45 22.5 4.97933 22.3043 4.588 21.913C4.196 21.521 4 21.05 4 20.5V4.5C4 3.95 4.196 3.479 4.588 3.087C4.97933 2.69567 5.45 2.5 6 2.5H14L20 8.5V20.5C20 21.05 19.8043 21.521 19.413 21.913C19.021 22.3043 18.55 22.5 18 22.5H6ZM13 9.5V4.5H6V20.5H18V9.5H13Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_20277">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomerIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_74679)">
        <mask
          id="mask0_726_74679"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_74679)">
          <path
            d="M16 13.5C15.2333 12.8 14.4877 12.1127 13.763 11.438C13.0377 10.7627 12.396 10.1 11.838 9.45C11.2793 8.8 10.8333 8.17067 10.5 7.562C10.1667 6.954 10 6.36667 10 5.8C10 4.86667 10.3167 4.08333 10.95 3.45C11.5833 2.81667 12.3667 2.5 13.3 2.5C13.8333 2.5 14.3333 2.61233 14.8 2.837C15.2667 3.06233 15.6667 3.36667 16 3.75C16.3333 3.36667 16.7333 3.06233 17.2 2.837C17.6667 2.61233 18.1667 2.5 18.7 2.5C19.6333 2.5 20.4167 2.81667 21.05 3.45C21.6833 4.08333 22 4.86667 22 5.8C22 6.36667 21.8333 6.954 21.5 7.562C21.1667 8.17067 20.721 8.8 20.163 9.45C19.6043 10.1 18.9667 10.7627 18.25 11.438C17.5333 12.1127 16.7833 12.8 16 13.5ZM16 10.8C16.9833 9.86667 17.896 8.93733 18.738 8.012C19.5793 7.08733 20 6.35 20 5.8C20 5.41667 19.8793 5.104 19.638 4.862C19.396 4.62067 19.0833 4.5 18.7 4.5C18.4667 4.5 18.246 4.54567 18.038 4.637C17.8293 4.729 17.65 4.86667 17.5 5.05L16 6.85L14.5 5.05C14.35 4.86667 14.171 4.729 13.963 4.637C13.7543 4.54567 13.5333 4.5 13.3 4.5C12.9167 4.5 12.6043 4.62067 12.363 4.862C12.121 5.104 12 5.41667 12 5.8C12 6.35 12.4207 7.08733 13.262 8.012C14.104 8.93733 15.0167 9.86667 16 10.8ZM14 23L7 21.05V22.5H1V11.5H8.95L15.15 13.8C15.7 14 16.146 14.35 16.488 14.85C16.8293 15.35 17 15.9 17 16.5H19C19.8333 16.5 20.5417 16.775 21.125 17.325C21.7083 17.875 22 18.6 22 19.5V20.5L14 23ZM3 20.5H5V13.5H3V20.5ZM13.95 20.9L19.9 19.05C19.85 18.8667 19.7373 18.729 19.562 18.637C19.3873 18.5457 19.2 18.5 19 18.5H14.2C13.6833 18.5 13.2167 18.4667 12.8 18.4C12.3833 18.3333 11.9333 18.2167 11.45 18.05L9.725 17.45L10.3 15.55L12.3 16.2C12.6 16.3 12.95 16.375 13.35 16.425C13.75 16.475 14.3 16.5 15 16.5C15 16.3167 14.946 16.1417 14.838 15.975C14.7293 15.8083 14.6 15.7 14.45 15.65L8.6 13.5H7V19L13.95 20.9Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_74679">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BranchIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_23083)">
        <mask
          id="mask0_726_23083"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_23083)">
          <path
            d="M12 16.975C13.65 15.6417 14.896 14.3583 15.738 13.125C16.5793 11.8917 17 10.7333 17 9.65C17 8.71667 16.8293 7.92067 16.488 7.262C16.146 6.604 15.725 6.07067 15.225 5.662C14.725 5.254 14.1833 4.95833 13.6 4.775C13.0167 4.59167 12.4833 4.5 12 4.5C11.5167 4.5 10.9833 4.59167 10.4 4.775C9.81667 4.95833 9.275 5.254 8.775 5.662C8.275 6.07067 7.85433 6.604 7.513 7.262C7.171 7.92067 7 8.71667 7 9.65C7 10.7333 7.42067 11.8917 8.262 13.125C9.104 14.3583 10.35 15.6417 12 16.975ZM12 19.5C9.65 17.7667 7.89567 16.0833 6.737 14.45C5.579 12.8167 5 11.2167 5 9.65C5 8.46667 5.21267 7.429 5.638 6.537C6.06267 5.64567 6.60833 4.9 7.275 4.3C7.94167 3.7 8.69167 3.25 9.525 2.95C10.3583 2.65 11.1833 2.5 12 2.5C12.8167 2.5 13.6417 2.65 14.475 2.95C15.3083 3.25 16.0583 3.7 16.725 4.3C17.3917 4.9 17.9377 5.64567 18.363 6.537C18.7877 7.429 19 8.46667 19 9.65C19 11.2167 18.4207 12.8167 17.262 14.45C16.104 16.0833 14.35 17.7667 12 19.5ZM12 11.5C12.55 11.5 13.021 11.304 13.413 10.912C13.8043 10.5207 14 10.05 14 9.5C14 8.95 13.8043 8.479 13.413 8.087C13.021 7.69567 12.55 7.5 12 7.5C11.45 7.5 10.9793 7.69567 10.588 8.087C10.196 8.479 10 8.95 10 9.5C10 10.05 10.196 10.5207 10.588 10.912C10.9793 11.304 11.45 11.5 12 11.5ZM5 22.5V20.5H19V22.5H5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_23083">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ComplaintIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_23033)">
        <mask
          id="mask0_726_23033"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_23033)">
          <path
            d="M11 11.5H13V5.5H11V11.5ZM12 15.5C12.2833 15.5 12.521 15.404 12.713 15.212C12.9043 15.0207 13 14.7833 13 14.5C13 14.2167 12.9043 13.979 12.713 13.787C12.521 13.5957 12.2833 13.5 12 13.5C11.7167 13.5 11.4793 13.5957 11.288 13.787C11.096 13.979 11 14.2167 11 14.5C11 14.7833 11.096 15.0207 11.288 15.212C11.4793 15.404 11.7167 15.5 12 15.5ZM2 22.5V4.5C2 3.95 2.196 3.479 2.588 3.087C2.97933 2.69567 3.45 2.5 4 2.5H20C20.55 2.5 21.021 2.69567 21.413 3.087C21.8043 3.479 22 3.95 22 4.5V16.5C22 17.05 21.8043 17.521 21.413 17.913C21.021 18.3043 20.55 18.5 20 18.5H6L2 22.5ZM4 17.675L5.175 16.5H20V4.5H4V17.675Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_23033">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ManageAccountIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_23053)">
        <mask
          id="mask0_726_23053"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_23053)">
          <path
            d="M10 12.5C8.9 12.5 7.95833 12.1083 7.175 11.325C6.39167 10.5417 6 9.6 6 8.5C6 7.4 6.39167 6.45833 7.175 5.675C7.95833 4.89167 8.9 4.5 10 4.5C11.1 4.5 12.0417 4.89167 12.825 5.675C13.6083 6.45833 14 7.4 14 8.5C14 9.6 13.6083 10.5417 12.825 11.325C12.0417 12.1083 11.1 12.5 10 12.5ZM2 20.5V17.7C2 17.15 2.14167 16.6333 2.425 16.15C2.70833 15.6667 3.1 15.3 3.6 15.05C4.45 14.6167 5.40833 14.25 6.475 13.95C7.54167 13.65 8.71667 13.5 10 13.5H10.35C10.45 13.5 10.55 13.5167 10.65 13.55C10.5167 13.85 10.404 14.1627 10.312 14.488C10.2207 14.8127 10.15 15.15 10.1 15.5H10C8.81667 15.5 7.754 15.65 6.812 15.95C5.87067 16.25 5.1 16.55 4.5 16.85C4.35 16.9333 4.22933 17.05 4.138 17.2C4.046 17.35 4 17.5167 4 17.7V18.5H10.3C10.4 18.85 10.5333 19.196 10.7 19.538C10.8667 19.8793 11.05 20.2 11.25 20.5H2ZM16 21.5L15.7 20C15.5 19.9167 15.3123 19.8293 15.137 19.738C14.9623 19.646 14.7833 19.5333 14.6 19.4L13.15 19.85L12.15 18.15L13.3 17.15C13.2667 16.9167 13.25 16.7 13.25 16.5C13.25 16.3 13.2667 16.0833 13.3 15.85L12.15 14.85L13.15 13.15L14.6 13.6C14.7833 13.4667 14.9623 13.354 15.137 13.262C15.3123 13.1707 15.5 13.0833 15.7 13L16 11.5H18L18.3 13C18.5 13.0833 18.6877 13.175 18.863 13.275C19.0377 13.375 19.2167 13.5 19.4 13.65L20.85 13.15L21.85 14.9L20.7 15.9C20.7333 16.1 20.75 16.3083 20.75 16.525C20.75 16.7417 20.7333 16.95 20.7 17.15L21.85 18.15L20.85 19.85L19.4 19.4C19.2167 19.5333 19.0377 19.646 18.863 19.738C18.6877 19.8293 18.5 19.9167 18.3 20L18 21.5H16ZM17 18.5C17.55 18.5 18.021 18.3043 18.413 17.913C18.8043 17.521 19 17.05 19 16.5C19 15.95 18.8043 15.479 18.413 15.087C18.021 14.6957 17.55 14.5 17 14.5C16.45 14.5 15.9793 14.6957 15.588 15.087C15.196 15.479 15 15.95 15 16.5C15 17.05 15.196 17.521 15.588 17.913C15.9793 18.3043 16.45 18.5 17 18.5ZM10 10.5C10.55 10.5 11.021 10.304 11.413 9.912C11.8043 9.52067 12 9.05 12 8.5C12 7.95 11.8043 7.47933 11.413 7.088C11.021 6.696 10.55 6.5 10 6.5C9.45 6.5 8.97933 6.696 8.588 7.088C8.196 7.47933 8 7.95 8 8.5C8 9.05 8.196 9.52067 8.588 9.912C8.97933 10.304 9.45 10.5 10 10.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_23053">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SettingLocation({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 3.5L20.34 3.53L15 5.6L9 3.5L3.36 5.4C3.15 5.47 3 5.65 3 5.88V21C3 21.1326 3.05268 21.2598 3.14645 21.3536C3.24021 21.4473 3.36739 21.5 3.5 21.5L3.66 21.47L9 19.4L15 21.5L20.64 19.6C20.85 19.53 21 19.35 21 19.12V4C21 3.86739 20.9473 3.74021 20.8536 3.64645C20.7598 3.55268 20.6326 3.5 20.5 3.5ZM10 5.97L14 7.37V19.03L10 17.63V5.97ZM5 6.96L8 5.95V17.65L5 18.81V6.96ZM19 18.04L16 19.05V7.36L19 6.2V18.04Z"
        fill={color}
      />
    </svg>
  );
}

export function HolidayIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_75121)">
        <mask
          id="mask0_726_75121"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_75121)">
          <path
            d="M10.95 18.85L7.4 15.3L8.85 13.85L10.95 15.95L15.15 11.75L16.6 13.2L10.95 18.85ZM5 22.5C4.45 22.5 3.979 22.3043 3.587 21.913C3.19567 21.521 3 21.05 3 20.5V6.5C3 5.95 3.19567 5.47933 3.587 5.088C3.979 4.696 4.45 4.5 5 4.5H6V2.5H8V4.5H16V2.5H18V4.5H19C19.55 4.5 20.021 4.696 20.413 5.088C20.8043 5.47933 21 5.95 21 6.5V20.5C21 21.05 20.8043 21.521 20.413 21.913C20.021 22.3043 19.55 22.5 19 22.5H5ZM5 20.5H19V10.5H5V20.5ZM5 8.5H19V6.5H5V8.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_75121">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function VoipIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_16743)">
        <mask
          id="mask0_726_16743"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_16743)">
          <path
            d="M16.5 11.4751C16.2167 11.4751 15.979 11.3794 15.787 11.1881C15.5957 10.9961 15.5 10.7584 15.5 10.4751C15.5 10.1918 15.5957 9.9541 15.787 9.7621C15.979 9.57076 16.2167 9.4751 16.5 9.4751C16.7833 9.4751 17.0207 9.57076 17.212 9.7621C17.404 9.9541 17.5 10.1918 17.5 10.4751C17.5 10.7584 17.404 10.9961 17.212 11.1881C17.0207 11.3794 16.7833 11.4751 16.5 11.4751ZM14 9.0251L12.95 7.9751C13.4333 7.49176 13.9793 7.12076 14.588 6.8621C15.196 6.6041 15.8333 6.4751 16.5 6.4751C17.1667 6.4751 17.8043 6.6041 18.413 6.8621C19.021 7.12076 19.5667 7.49176 20.05 7.9751L19 9.0251C18.6667 8.69176 18.2877 8.43343 17.863 8.2501C17.4377 8.06676 16.9833 7.9751 16.5 7.9751C16.0167 7.9751 15.5623 8.06676 15.137 8.2501C14.7123 8.43343 14.3333 8.69176 14 9.0251ZM11.9 6.8751L10.85 5.8251C11.6 5.0751 12.4627 4.49576 13.438 4.0871C14.4127 3.6791 15.4333 3.4751 16.5 3.4751C17.5667 3.4751 18.5873 3.6791 19.562 4.0871C20.5373 4.49576 21.4 5.0751 22.15 5.8251L21.1 6.8751C20.4833 6.25843 19.7793 5.78743 18.988 5.4621C18.196 5.13743 17.3667 4.9751 16.5 4.9751C15.6333 4.9751 14.8083 5.14176 14.025 5.4751C13.2417 5.80843 12.5333 6.2751 11.9 6.8751ZM19.95 21.5001C17.8 21.5001 15.7043 21.0208 13.663 20.0621C11.621 19.1041 9.81267 17.8374 8.238 16.2621C6.66267 14.6874 5.396 12.8791 4.438 10.8371C3.47933 8.79576 3 6.7001 3 4.5501C3 4.2501 3.1 4.0001 3.3 3.8001C3.5 3.6001 3.75 3.5001 4.05 3.5001H8.1C8.33333 3.5001 8.54167 3.5751 8.725 3.7251C8.90833 3.8751 9.01667 4.06676 9.05 4.3001L9.7 7.8001C9.73333 8.03343 9.72933 8.24576 9.688 8.4371C9.646 8.6291 9.55 8.8001 9.4 8.9501L6.975 11.4001C7.675 12.6001 8.55433 13.7251 9.613 14.7751C10.671 15.8251 11.8333 16.7334 13.1 17.5001L15.45 15.1501C15.6 15.0001 15.796 14.8874 16.038 14.8121C16.2793 14.7374 16.5167 14.7168 16.75 14.7501L20.2 15.4501C20.4333 15.5001 20.625 15.6124 20.775 15.7871C20.925 15.9624 21 16.1668 21 16.4001V20.4501C21 20.7501 20.9 21.0001 20.7 21.2001C20.5 21.4001 20.25 21.5001 19.95 21.5001ZM6.025 9.5001L7.675 7.8501L7.25 5.5001H5.025C5.10833 6.18343 5.225 6.85843 5.375 7.5251C5.525 8.19176 5.74167 8.8501 6.025 9.5001ZM14.975 18.4501C15.625 18.7334 16.2877 18.9584 16.963 19.1251C17.6377 19.2918 18.3167 19.4001 19 19.4501V17.2501L16.65 16.7751L14.975 18.4501Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_16743">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SmsBlastIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 17.5V7.5H4V17.5H11ZM11 3.5C11.5304 3.5 12.0391 3.71071 12.4142 4.08579C12.7893 4.46086 13 4.96957 13 5.5V19.5C13 20.0304 12.7893 20.5391 12.4142 20.9142C12.0391 21.2893 11.5304 21.5 11 21.5H4C3.46957 21.5 2.96086 21.2893 2.58579 20.9142C2.21071 20.5391 2 20.0304 2 19.5V5.5C2 4.96957 2.21071 4.46086 2.58579 4.08579C2.96086 3.71071 3.46957 3.5 4 3.5H11ZM16.5 3.5H21.5C21.8978 3.5 22.2794 3.65804 22.5607 3.93934C22.842 4.22064 23 4.60218 23 5V8C23 8.39782 22.842 8.77936 22.5607 9.06066C22.2794 9.34196 21.8978 9.5 21.5 9.5H18L15 12.5V5C15 4.60218 15.158 4.22064 15.4393 3.93934C15.7206 3.65804 16.1022 3.5 16.5 3.5Z"
        fill={color}
      />
    </svg>
  );
}

export function DeleteIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_864_39062)">
        <mask
          id="mask0_864_39062"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_864_39062)">
          <path
            d="M7 21.5C6.45 21.5 5.97933 21.3043 5.588 20.913C5.196 20.521 5 20.05 5 19.5V6.5H4V4.5H9V3.5H15V4.5H20V6.5H19V19.5C19 20.05 18.8043 20.521 18.413 20.913C18.021 21.3043 17.55 21.5 17 21.5H7ZM17 6.5H7V19.5H17V6.5ZM9 17.5H11V8.5H9V17.5ZM13 17.5H15V8.5H13V17.5Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_864_39062">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LogIcon({ color = defaultColor }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_726_3532)">
        <mask
          id="mask0_726_3532"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_726_3532)">
          <path
            d="M12 21.5C9.7 21.5 7.696 20.7373 5.988 19.212C4.27933 17.6873 3.3 15.7833 3.05 13.5H5.1C5.33333 15.2333 6.104 16.6667 7.412 17.8C8.72067 18.9333 10.25 19.5 12 19.5C13.95 19.5 15.604 18.8207 16.962 17.462C18.3207 16.104 19 14.45 19 12.5C19 10.55 18.3207 8.89567 16.962 7.537C15.604 6.179 13.95 5.5 12 5.5C10.85 5.5 9.775 5.76667 8.775 6.3C7.775 6.83333 6.93333 7.56667 6.25 8.5H9V10.5H3V4.5H5V6.85C5.85 5.78333 6.88767 4.95833 8.113 4.375C9.33767 3.79167 10.6333 3.5 12 3.5C13.25 3.5 14.421 3.73733 15.513 4.212C16.6043 4.68733 17.5543 5.329 18.363 6.137C19.171 6.94567 19.8127 7.89567 20.288 8.987C20.7627 10.079 21 11.25 21 12.5C21 13.75 20.7627 14.9207 20.288 16.012C19.8127 17.104 19.171 18.054 18.363 18.862C17.5543 19.6707 16.6043 20.3127 15.513 20.788C14.421 21.2627 13.25 21.5 12 21.5ZM14.8 16.7L11 12.9V7.5H13V12.1L16.2 15.3L14.8 16.7Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_726_3532">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
